import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {store} from './store/index'
import vuetify from './plugins/vuetify';
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import '@/assets/css/style.css'


moment.tz.setDefault('Asia/Colombo');


Vue.config.productionTip = false



new Vue({
  router,
  store,
  VueMoment,
  vuetify,
  render: h => h(App)
}).$mount('#app')
